import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@shared';

import { components } from './components';
import { containers } from './containers';
import { services } from './services';
import { effects } from './effects';
import { reducers } from './reducers';

@NgModule({
  declarations: [...containers, ...components],
  providers: [...services],
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    RouterModule,
    EffectsModule.forFeature(effects),
    StoreModule.forFeature('email', reducers),
  ],
})
export class EmailModule {}
